module.exports = __webpack_public_path__ + "static/media/redCross2.cfff30b6.png";